import { render } from "./Page-About.vue?vue&type=template&id=4eb6ed7a&scoped=true"
import script from "./Page-About.vue?vue&type=script&lang=js"
export * from "./Page-About.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4eb6ed7a"

export default script